module.exports = __webpack_public_path__ + "static/media/snekre.eee18215.m4a";